// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export {
  listByResourceGroup,
  listBySubscriptionId,
  $delete,
  update,
  createOrUpdate,
  get,
} from "./operations.js";
export type {
  VaultsListByResourceGroupOptionalParams,
  VaultsListBySubscriptionIdOptionalParams,
  VaultsDeleteOptionalParams,
  VaultsUpdateOptionalParams,
  VaultsCreateOrUpdateOptionalParams,
  VaultsGetOptionalParams,
} from "./options.js";
